import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buscarSiniestro, clearReintegros, clearSelectedSiniestro, setLocalSiniestro, } from "../../../redux/actions/reintegros";
import { StyledSiniestro } from "../../styled/Reintegros";
import SiniestroForm from "./SiniestroForm";
import SiniestroTable from "./SiniestroTable";

const initialValues = {
  nroSiniestro: "",
  nroDocumento: "",
};

const SiniestroContainer = ({ fromBread, nextForm }) => {
  const dispatch = useDispatch();

  const selectedSiniestroRedux = useSelector(
    (state) => state.reintegros.localSiniestro
  );
  const searchedSiniestro = useSelector(
    (state) => state.reintegros.siniestrosBuscados
  );

  const [formModel, setFormModel] = useState(null);
  const [selectedSiniestro, setSelectedSiniestro] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const isLoading = !formModel;

  useEffect(() => {
    if (!fromBread) {
      dispatch(clearSelectedSiniestro());
      dispatch(clearReintegros());
    }
  }, []);

  useEffect(() => {
    setFormModel(() => ({
      ...initialValues,
      nroSiniestro:
        selectedSiniestroRedux && fromBread
          ? selectedSiniestroRedux.numeroSiniestroART
          : initialValues.nroSiniestro,
      nroDocumento:
        selectedSiniestroRedux && fromBread
          ? selectedSiniestroRedux.numeroDocumento
          : initialValues.nroDocumento,
    }));
  }, []);

  useEffect(() => {
    if (searchedSiniestro.data.length >= 1) {
      setSelectedSiniestro(searchedSiniestro.data[0]);
    } else {
      setSelectedSiniestro(null);
    }
  }, [searchedSiniestro.data.length]);

  const handleSubmit = () => {
    dispatch(setLocalSiniestro(selectedSiniestro));
    nextForm("Beneficiario");
  };

  const handleSubmitSearchForm = (values) => {
    if (values.nroSiniestro === "" && values.nroDocumento === "") {
      setShowErrorMessage(true);
      return;
    } else {
      setShowErrorMessage(false);
      dispatch(clearSelectedSiniestro());
      dispatch(buscarSiniestro(values));
    }
  };

  return (
    <StyledSiniestro.Container>
      <div>
        <Typography variant="h6">Selección del siniestro</Typography>
      </div>
      <StyledSiniestro.WarningMessageContainer>
        <ErrorOutlineIcon sx={{ color: "red" }} fontSize="large" />
        <Typography variant="h6" style={{ paddingLeft: 10, color: "red" }}>
          Para solicitar el Reintegro debe completar CBU/CVU y adjuntar el
          comprobante
        </Typography>
      </StyledSiniestro.WarningMessageContainer>
      <StyledSiniestro.FormContainer>
        <SiniestroForm
          handleSubmit={handleSubmitSearchForm}
          model={formModel}
          isLoading={isLoading}
        />
      </StyledSiniestro.FormContainer>
      <StyledSiniestro.ErrorContainer>
        {showErrorMessage && (
          <>
            <ErrorOutlineIcon style={{ color: "red" }} fontSize="medium" />
            <Typography style={{ color: "red" }}>
              Debe completar alguno de los dos campos
            </Typography>
          </>
        )}
      </StyledSiniestro.ErrorContainer>
      <StyledSiniestro.TableContainer>
        <SiniestroTable
          selectedSiniestro={selectedSiniestro}
          searchedSiniestro={searchedSiniestro}
          handleSubmit={setSelectedSiniestro}
        />
      </StyledSiniestro.TableContainer>
      <StyledSiniestro.ButtonContainer>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!selectedSiniestro}
        >
          Siguiente
        </Button>
      </StyledSiniestro.ButtonContainer>
    </StyledSiniestro.Container>
  );
};

export default SiniestroContainer;